import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import ChatMessage from "./ChatMessage";
import { Spin } from "antd";
import {
	Container,
	SpinWrapper,
	InitialMessage,
	MessageText,
	EmptyText,
} from "../Message.style";
import { useTranslation } from "react-i18next";
import { ADMIN_LK } from "@constants";

const Loader = () => (
	<SpinWrapper>
		<Spin size="small" />
	</SpinWrapper>
);

const Timeline = ({
	items,
	fetch,
	innerRef,
	disabled,
	hasMore,
	date,
	loading,
	device_info,
}) => {
	const { t } = useTranslation();

	const initialMsg = !hasMore && !date && (
		<InitialMessage size={!hasMore && items.length === 0 ? "large" : "small"}>
			<MessageText sender={ADMIN_LK}>{t("message.greetingMsg")}</MessageText>
		</InitialMessage>
	);

	const endMessage = !loading && date && items.length === 0 && (
		<EmptyText>{t("common.noRecord")}</EmptyText>
	);

	return (
		<div style={{ padding: "0 16px" }}>
			<Container ref={innerRef}>
				<InfiniteScroll
					inverse={true}
					dataLength={items.length}
					next={fetch}
					hasMore={hasMore && !disabled}
					endMessage={endMessage}
					loader={<Loader />}
					scrollableTarget="scrollableDiv"
					style={{
						//To put endMessage and loader to the top.
						display: "flex",
						flexDirection: "column-reverse",
					}}
				>
					{items.map((item, index) => (
						<ChatMessage key={index} index={index} item={item} items={items} device_info={device_info} />
					))}
					{initialMsg}
					{loading && items.length === 0 && <Loader />}
				</InfiniteScroll>
			</Container>
		</div>
	);
};

export default Timeline;
